import React, { useState, useRef, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import placedIcon from "../../assets/profile/placed_icon.png";
import packedIcon from "../../assets/profile/packed_icon.png";
import shippedIcon from "../../assets/profile/shipped_icon.png";
import deliveryIcon from "../../assets/profile/oud_icon.png";
import deliveredIcon from "../../assets/profile/dene_icon.png";
import refundIcon from "../../assets/profile/refund.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import uploadicon from "../../assets/profile/upload_icon.png";
export default function OrdersOffCanvas({
  isOpen,
  onClose,
  action,
  productId,
}) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const options = ["Item is damaged", "Wrong product", "Something else"];
  const [images, setImages] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const MAX_FILES = 10;
  const handleFiles = (files) => {
    const filesArray = Array.from(files);
    // Check total limit
    if (images.length + filesArray.length > MAX_FILES) {
      alert(`You can upload maximum ${MAX_FILES} images only`);
      return;
    }

    const imagesFiles = filesArray.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setImages((prev) => [...prev, ...imagesFiles]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => {
    setDragActive(false);
  };
  // Input change
  const handleChange = (e) => {
    handleFiles(e.target.files);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
    setDragActive(false);
  };
  // Remove image
  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const dropdownRef = useRef(null);
  const steps = [
    {
      id: 1,
      label: "Order Placed",
      date: "26 Dec 2025",
      time: "09:00 AM",
      icon: placedIcon,
    },
    { id: 2, label: "Order Packed", date: "", time: "", icon: packedIcon },
    { id: 3, label: "Order Shipped", date: "", time: "", icon: shippedIcon },
    {
      id: 4,
      label: "Out for Delivery",
      date: "",
      time: "",
      icon: deliveryIcon,
    },
    { id: 5, label: "Delivered", date: "", time: "", icon: deliveredIcon },
  ];
  const stepsReturn = [
    {
      id: 1,
      label: "Initiated",
      date: "26 Dec 2025",
      time: "09:00 AM",
      icon: placedIcon,
    },
    { id: 2, label: "Pickup scheduled", date: "", time: "", icon: packedIcon },
    { id: 3, label: "Picked up", date: "", time: "", icon: shippedIcon },
    {
      id: 4,
      label: "Refund issued",
      date: "",
      time: "",
      icon: refundIcon,
    },
    {
      id: 5,
      label: "Refund credited",
      date: "",
      time: "",
      icon: deliveredIcon,
    },
  ];
  const [activeStep, setActiveStep] = useState(1);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    

    // cleanup (important)
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);
  console.log(action, productId);

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-[#113b1880] backdrop-blur-sm z-40"
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 z-50 h-screen w-full mx-auto md:w-2/3
  lg:w-1/2 2xl:w-1/3
  bg-white transition-transform duration-300 ease-in-out
  flex flex-col overflow-hidden  /* Added: Flex column and hide outer overflow */
  ${isOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* Header - Stays Fixed at Top */}
        <div className="flex justify-end pt-6 px-6 md:pt-8  md:px-8 flex-shrink-0">
          <button
            onClick={onClose}
            className="w-6 h-6 flex items-center justify-center rounded-full border border-[#29562f] text-[#29562f]"
          >
            <CloseIcon sx={{ fontSize: 16 }} />
          </button>
        </div>

        {/* Content Area - This part will now scroll */}
        {action === "details" && (
          <>
            <div className="flex-1 overflow-y-auto 3xl:px-20 md:px-10 px-5 pb-10">
              {" "}
              {/* Added: flex-1 and overflow-y-auto */}
              <h2 className="sm:text-base text-xl md:text-[26px] leading-[24px] font-medium font-lexend">
                Your order is being processed
              </h2>
              <p className="sm:text-sm text-base md:text-lg mt-1 text-[#333] font-lexend">
                Will be delivered by April 15
              </p>
              {/* Payment Info Grid */}
              <div className="grid xs:grid-cols-1 grid-cols-2 md:text-lg sm:text-sm text-base font-lexend gap-1 mt-4">
                <div className="flex flex-col sm:py-2 py-4 sm:rounded-[10px] rounded-l-[10px] justify-center items-center bg-[#e9f6e8]">
                  <p className="font-light">Payment type</p>
                  <p className="font-semibold">Prepaid</p>
                </div>
                <div className="flex flex-col justify-center sm:py-2 py-4 sm:rounded-[10px] rounded-r-[10px] items-center bg-[#e9f6e8]">
                  <p className="font-light">Payment_ID</p>
                  <p className="font-semibold">PAY_DVGENGYR</p>
                </div>
              </div>
              {/* Stepper logic */}
              <div className="flex flex-col sm:justify-start justify-center items-center mt-6">
                {steps.map((step, index) => (
                  <div
                    key={step.id}
                    className="flex justify-start sm:w-full sm:ps-16 xs:ps-8 gap-8"
                  >
                    <div className="flex flex-col items-center md:w-32">
                      <img
                        src={step.icon}
                        alt=""
                        className={`w-auto h-auto ${index + 1 > activeStep ? "opacity-40" : ""}`}
                      />
                      {index !== steps.length - 1 && (
                        <div
                          className={`w-[2px] my-2 h-9 ${index < activeStep ? "bg-[#8eba93]" : "bg-gray-300"}`}
                        ></div>
                      )}
                    </div>
                    <div className="md:w-60">
                      <p
                        className={`font-semibold sm:text-sm md:text-xl font-lexend mt-3 ${index + 1 <= activeStep ? "text-black" : "text-gray-400"}`}
                      >
                        {step.label}
                      </p>
                      <p className="sm:text-sm text-base md:text-lg font-medium font-lexend text-gray-500">
                        {step.date} <span>{step.time}</span>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Footer - Stays fixed at the bottom of the drawer */}
            <div className="w-full bg-[#f6eb9a] py-4 md:py-8 flex flex-col md:flex-row gap-4 justify-center items-center flex-shrink-0">
              <p className="text-base font-lexend font-light text-[#6d6d6d]">
                Cancellation available till shipping
              </p>
              <button className="bg-[#f50633] py-2 px-4 rounded-[10px] sm:text-base text-2xl text-white font-lexend">
                Cancel order
              </button>
            </div>
          </>
        )}
        {action === "return" && (
          <>
            <div className="flex-1 overflow-y-auto 3xl:px-20 md:px-10 px-5 pb-10">
              {" "}
              {/* Added: flex-1 and overflow-y-auto */}
              <h2 className="text-4xl sm:text-2xl leading-[24px] font-bold mt-5 text-[#333333] font-lexend">
                Request a return
              </h2>
              {/* Stepper logic */}
              <div className="flex flex-col sm:mt-6 mt-14">
                <div className="relative">
                  <label className="text-[22px] sm:text-lg leading-[28px] font-medium font-lexend text-[#333333]">
                    Reason for return
                  </label>
                  {/* Button */}
                  <button
                    onClick={() => setOpen(!open)}
                    className="border border-[#b1b1b1] rounded-lg px-4 sm:py-1.5 py-2.5 mt-2 flex items-center justify-between gap-4 cursor-pointer bg-white w-full"
                  >
                    <span className="font-medium sm:text-sm text-lg text-[#585858]">
                      {selected || "Select option"}{" "}
                    </span>
                    <ExpandMoreIcon
                      sx={{ fontSize: 26 }}
                      className={`text-[#afafaf] transition-transform ${
                        open ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {/* Dropdown */}
                  {open && (
                    <ul className="absolute z-10 mt-2 w-full bg-white border border-[#b1b1b1] rounded-lg shadow-md overflow-hidden font-lexend">
                      {options.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            setSelected(item);
                            setOpen(false);
                          }}
                          className="px-4 py-2 sm:text-sm text-lg cursor-pointer hover:bg-blue-100"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="relative sm:mt-4 mt-8">
                  <label className="text-[22px] sm:text-lg leading-[28px] font-medium font-lexend text-[#333333]">
                    Upload images
                  </label>
                  <div className="w-full max-w-xl mx-auto sm:mt-2 mt-4">
                    {/* Drop Area */}
                    <div
                      className={`border border-dashed rounded-xl p-6 text-center cursor-pointer transition 
        ${dragActive ? "border-blue-500 bg-blue-50" : "border-[#b1b1b1]"}`}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                    >
                      <input
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={handleChange}
                        className="hidden"
                        id="upload"
                      />

                      <label
                        htmlFor="upload"
                        className="cursor-pointer flex flex-col justify-center gap-1 items-center"
                      >
                        <img src={uploadicon} alt="upload icon" />
                        <p className="text-[#585858] sm:text-sm text-lg font-lexend pt-2">
                          Drag and drop image here
                        </p>
                        <span className="text-[#2c6fde] font-semibold text-lg  sm:text-sm font-lexend underline underline-offset-2">
                          Browse files
                        </span>
                      </label>
                    </div>

                    {/* Preview */}
                    {images.length > 0 && (
                      <div className="grid sm:grid-cols-3 grid-cols-5 gap-4 sm:mt-4 mt-8">
                        {images.map((img, index) => (
                          <div
                            key={index}
                            className="relative group rounded-lg overflow-hidden border-2 border-white hover:border-gray-400"
                          >
                            <img
                              src={img.preview}
                              alt="preview"
                              className=" w-20 sm:h-16 h-20 "
                            />

                            {/* Remove button */}
                            <button
                              onClick={() => removeImage(index)}
                              className="absolute top-1 right-1 bg-black/60 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              ✕
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="relative sm:mt-4 mt-8">
                  <label className="text-[22px] sm:text-lg leading-[28px] font-medium font-lexend text-[#333333]">
                    Your comments
                  </label>
                  <div className="sm:mt-2 mt-4">
                    <textarea
                      rows={5}
                      className="border-[#b1b1b1] outline-none focus:border-blue-400 resize-none border rounded-lg px-4 py-2.5 w-full"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Footer - Stays fixed at the bottom of the drawer */}
            <div className="w-full bg-[#f6eb9a] py-4 md:py-8 sm:px-8 px-20 flex sm:justify-center  justify-end items-center flex-shrink-0">
              <button className="bg-[#2f5d3a] py-2 px-6 rounded-[10px] sm:text-base text-[22px] text-[#f6eb9a] font-lexend">
                Submit a request
              </button>
            </div>
          </>
        )}
        {action === "trackreturn" && (
          <>
            <div className="flex-1 overflow-y-auto 3xl:px-20 md:px-10 px-5 pb-10">
              {" "}
              {/* Added: flex-1 and overflow-y-auto */}
              <h2 className="sm:text-base text-xl md:text-[26px] leading-[24px] font-medium font-lexend">
                Your return is being processed
              </h2>
              <p className="sm:text-sm text-base md:text-lg mt-1 text-[#333] font-lexend">
                Your refund will be issued by April 15
              </p>
              {/* Payment Info Grid */}
              <div className="grid xs:grid-cols-1 grid-cols-2 md:text-lg sm:text-sm text-base font-lexend gap-1 mt-4">
                <div className="flex flex-col sm:py-2 py-4 sm:rounded-[10px] rounded-l-[10px] justify-center items-center bg-[#e9f6e8]">
                  <p className="font-light">Payment type</p>
                  <p className="font-semibold">Prepaid</p>
                </div>
                <div className="flex flex-col justify-center sm:py-2 py-4 sm:rounded-[10px] rounded-r-[10px] items-center bg-[#e9f6e8]">
                  <p className="font-light">Payment_ID</p>
                  <p className="font-semibold">PAY_DVGENGYR</p>
                </div>
              </div>
              {/* Stepper logic */}
              <div className="flex flex-col sm:justify-start justify-center items-center mt-6">
                {stepsReturn.map((step, index) => (
                  <div
                    key={step.id}
                    className="flex justify-start sm:w-full sm:ps-16 xs:ps-8 gap-8"
                  >
                    <div className="flex flex-col items-center md:w-32">
                      <img
                        src={step.icon}
                        alt=""
                        className={`w-auto h-auto ${index + 1 > activeStep ? "opacity-40" : ""}`}
                      />
                      {index !== stepsReturn.length - 1 && (
                        <div
                          className={`w-[2px] my-2 h-9 ${index < activeStep ? "bg-[#8eba93]" : "bg-gray-300"}`}
                        ></div>
                      )}
                    </div>
                    <div className="md:w-60">
                      <p
                        className={`font-semibold sm:text-sm md:text-xl font-lexend mt-3 ${index + 1 <= activeStep ? "text-black" : "text-gray-400"}`}
                      >
                        {step.label}
                      </p>
                      <p className="sm:text-sm text-base md:text-lg font-medium font-lexend text-gray-500">
                        {step.date} <span>{step.time}</span>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Footer - Stays fixed at the bottom of the drawer */}
            <div className="w-full bg-[#f6eb9a] py-4 md:py-8 sm:px-8 px-20 flex sm:justify-center  justify-end items-center flex-shrink-0">
              <button className="bg-[#2f5d3a] py-2 px-6 rounded-[10px] sm:text-base text-[22px] text-[#f6eb9a] font-lexend">
                Refund invoice
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
